export type MonacoWorkerConstructor = new () => Worker;

export type MonacoWorkerCtors = {
  editor: MonacoWorkerConstructor;
  json: MonacoWorkerConstructor;
  css: MonacoWorkerConstructor;
  html: MonacoWorkerConstructor;
  ts: MonacoWorkerConstructor;
};

/** Pure factory used by MonacoEnvironment.getWorker (injectable for tests). */
export function createMonacoWorkerFactory(
  workers: MonacoWorkerCtors
): (workerId: string, label: string) => Worker {
  return (_workerId: string, label: string): Worker => {
    switch (label) {
      case 'json':
        return new workers.json();
      case 'css':
      case 'scss':
      case 'less':
        return new workers.css();
      case 'html':
      case 'handlebars':
      case 'razor':
        return new workers.html();
      case 'typescript':
      case 'javascript':
        return new workers.ts();
      default:
        return new workers.editor();
    }
  };
}
